import _ from 'lodash-es';
import Defaults from '~/scripts/constants/defaults';
import FileUpload from '~/scripts/services/model/file-upload';
import Node from '~/scripts/services/model/node';
import { ConfirmDeleteModal } from '~/utils/modals';
import APIV5 from '~/models/api';
import { Confirm } from '~/scripts/services/modal/modal';

/* globals Knitiv */

export default class OoAdminController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').IQService} $q
	 * @param {*} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {*} NodeService
	 * @param {*} Notification
	 * @param {import('angular').ISCEService} $sce
	 * @param {Knitiv.RootScope} $rootScope
	 */
	constructor(
		$injector,
		$location,
		$q,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		NodeService,
		Notification,
		$sce,
		$rootScope,
	) {
		this.defaults = Defaults;

		/** @type {'YES' | 'NO'} */
		this.droitForce = 'NO';

		/** @type {'YES' | 'NO'} */
		this.droitDefForce = 'NO';

		this.node = undefined;

		this.$location = $location;
		this.$rootScope = $rootScope;

		/** @type {?import('angular').IFormController} */
		this.form = null;

		/** @type {?string} */
		this.tab = null;

		this.objectsLength = 0;

		/** @type {any} */
		this.oldNode = null;

		/** @type {?Function} */
		this.onCancel = null;

		/** @type {?Function} */
		this.onCreated = null;

		/** @type {?Function} */
		this.onDeleted = null;

		/** @type {?Function} */
		this.onUpdated = null;

		/** @type {any} */
		this.options = undefined;

		this.shapes = undefined;
		this.tmpFile = new FileUpload($injector);
		this.typeKidOptions = [
			'K_NODE;STRING',
			'K_NODE;TEXT',
			'K_NODE;BOOL',
			'K_NODE;JSON',
			'K_NODE;HTML',
			'K_NODE;INTEGER',
			'K_NODE;DOUBLE',
			'K_NODE;DOUBLE8',
			'K_NODE;DATE',
			'K_NODE;HASH',
			'K_NODE;CRYPT',
		];

		this.$q = $q;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.NodeService = NodeService;
		this.Notification = Notification;
		this.$sce = $sce;
		this.$injector = $injector;
	}

	async cancel() {
		const modal = new Confirm(this.$injector);
		const done = await modal.open({
			title: this.$translate.instant('common.confirmation'),
			body: this.$sce.trustAsHtml(`Veuillez confirmer le vidage du formulaire <br> <b>${this.node.getName()}</b>`),
			cancel: {
				label: 'Fermer',
			},
			accept: {
				label: 'Annuler le formulaire',
			},
		});
		if (done) {
			if (!this.node.create) {
				this.node = { ...this.oldNode };
				this.form?.$setPristine();
				this.form?.$setUntouched();
			}
			this.tmpFile.reset();
			if (typeof this.onCancel === 'function') {
				this.onCancel();
			}
		}
	}

	async delete() {
		const modal = new ConfirmDeleteModal(this.$injector);
		const answer = await modal.open(this.node.getName());

		if (answer) {
			await this.NodeService.delete(this.node.kid);
			if (typeof this.onDeleted === 'function') {
				this.onDeleted();
			}
			this.node = undefined;
		}
	}

	download() {
		if (this.node.checkDroit(Defaults.DROIT.READ)) {
			const url = APIV5.instance.downloadURL({
				nodeid: this.node.kid,
			});
			window.open(url, '_self');
		}
	}

	export() {
		if (this.node.checkDroit(Defaults.DROIT.READ)) {
			this.NodeService.download(this.node.kid);
		}
	}

	isFormDisabled() {
		return !this.node || this.form?.$pristine || this.form?.$invalid || !!this.options.disabled;
	}

	isNode() {
		return this.node instanceof Node;
	}

	isAdmin() {
		return this.$rootScope.context?.profil.admin;
	}

	/**
	 * @param {'AllObjectOfClass' | 'AllInherits' | 'AllObjectOfClassInherits' | 'self'} mode
	 */
	async permissionPopulate(mode) {
		const populate = await this.NodeService.permissionPopulate(this.node, mode);
		if (populate) {
			this.Notification.info({
				title:   this.$translate.instant('object.successfully-updated-title'),
				message: this.$translate.instant('object.successfully-updated-message'),
			});
		}
	}

	async save() {
		const { create } = this.node;

		await this.uploadFile();
		const result = await this.NodeService.set([this.node], true, this.droitForce, this.droitDefForce);
		this.oldNode = { ...this.node };
		if (create) {
			if (typeof this.onCreated === 'function') {
				this.onCreated();
			}
		}
		// The modal has be submitted
		else if (typeof this.onUpdated === 'function' && result) {
			this.onUpdated();
		}
		if (result) {
			this.$timeout(() => {
				this.form?.$setPristine();
				this.form?.$setUntouched();
			});
		}
	}

	setName() {
		this.tab = 'repre';
	}

	setObjectTabActive() {
		this.tab = 'object';
	}

	/**
	 * @param {File} file
	 */
	upload(file) {
		this.tmpFile.file = file;
		this.tmpFile.name = file.name;
		this.tmpFile.packetindex = 1;
		this.form?.$setDirty();
	}

	async uploadFile() {
		const deferred = this.$q.defer();
		if (this.tmpFile.file) {
			await this.tmpFile.file.upload();
			if (this.tmpFile.id) {
				await APIV5.instance.nodeSetFile(
					{ nodeid: this.node.kid, fileid: this.tmpFile.id },
					{ id: 'oo-admin.upload-file' },
				);
			}
		}
		else {
			deferred.resolve(true);
		}
		return deferred.promise;
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.node) {
			this.$onInit();
			if (this.form) {
				this.form.$setDirty();
			}
		}
	}

	$onInit() {
		this.$scope.$on('admin-oo-object-list-length', (/** @type {Event} */ event, /** @type {number} */ l) => {
			this.objectsLength = l;
		});

		this.$scope.$on('admin-oo-set-form-dirty', () => {
			this.form?.$setDirty();
		});

		if (this.options.root) {
			this.$scope.$watch('$ctrl.tab', (/** @type {?string} */ tab, /** @type {?string} */ oldTab) => {
				if (tab && tab !== oldTab && this.node) {
					this.$location.path(`/admin/oo/${this.node.kid}/${tab}`);
				}
			});
		}

		_.extend({
			delete:         false,
			disabled:       false,
			headerButtons:  true,
			dicoLocked:     false,
		}, this.options);

		this.shapes = this.options?.schemaNode?.shapes;

		this.filterLinks = (/** @type {any} */ link) => !this.NodeService.dynRelations().includes(link.relation_kid);
	}
}
